export default "__VITE_ASSET__CRgaPhpJ__"